// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAsj2zqNkc1Oj2u-ZMzxpXi9nkQTWyQMu0",
  authDomain: "mubashir-curtain.firebaseapp.com",
  databaseURL: "https://mubashir-curtain-default-rtdb.firebaseio.com",
  projectId: "mubashir-curtain",
  storageBucket: "mubashir-curtain.appspot.com",
  messagingSenderId: "679318311353",
  appId: "1:679318311353:web:50d8648ca36d02ada72668",
  measurementId: "G-RVRMG6PT2P",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export default app;
